// BEUS-11496 M3: 신규 `/v2/heatmap` 경로는 켜야만 쓴다(기본 꺼짐 = 지금 화면 동작 그대로).
// 켜는 방법(위에 있을수록 우선):
// 1. 탭 하나만: 주소에 `?heatmapV2=on | pageViews | off`를 붙인다. 그 탭의 sessionStorage에 남아
//    새로고침·화면 이동 뒤에도 그 탭에서만 유지된다. 기존 화면(다른 탭)과 나란히 비교할 때 쓴다.
//    (localStorage는 같은 도메인의 모든 탭이 같이 쓰므로 나란히 비교가 안 된다.)
// 2. 이 브라우저 전체: localStorage.setItem('heatmapV2', 'on' | 'pageViews' | 'off')
// 3. 빌드 설정: VUE_APP_HEATMAP_V2=true -> 'on'
// 'on'은 신규 v2(CH)를 켠다. Scroll 분모 = Scroll 문서 수(기존 화면과 같은 뜻, 10/16 P0 D6 확정)라 기본값이다.
// 'pageViews'는 v2를 켜되 분모 = Visit PV(10/7 임시안, 보류). 비교용으로만 남긴다.
// 'off'는 아래 단계 설정을 무시하고 끈다.
// 'legacy'는 10/21 전 이름이다. 이미 공유된 주소·저장값이 깨지지 않게 'on'으로 받는다.

export const HEATMAP_V2_KEY = 'heatmapV2'
const MODES = ['on', 'pageViews']
const ALIASES = { legacy: 'on' }

// 알 수 없는 값은 null(그 단계 설정 없음으로 본다).
function normalize (value) {
  const v = Object.prototype.hasOwnProperty.call(ALIASES, value) ? ALIASES[value] : value
  return v === 'off' || MODES.includes(v) ? v : null
}

function readQuery () {
  try {
    return normalize(new URLSearchParams(window.location.search).get(HEATMAP_V2_KEY))
  } catch (e) {
    return null
  }
}

function readStorage (name) {
  try {
    return normalize(window[name].getItem(HEATMAP_V2_KEY))
  } catch (e) {
    return null
  }
}

// 지금 켜진 모드와 그 설정이 어디서 왔는지. { mode: 'on'|'pageViews'|null, source: 'url'|'tab'|'browser'|'build'|null }
export function heatmapV2State () {
  const query = readQuery()
  if (query) {
    try {
      window.sessionStorage.setItem(HEATMAP_V2_KEY, query)
    } catch (e) {
      // sessionStorage를 못 쓰면 이번 주소에서만 적용된다.
    }
  }
  const layers = [[query, 'url'], [readStorage('sessionStorage'), 'tab'], [readStorage('localStorage'), 'browser']]
  for (const [value, source] of layers) {
    if (value === 'off') return { mode: null, source }
    if (value) return { mode: value, source }
  }
  if (process.env.VUE_APP_HEATMAP_V2 === 'true') return { mode: 'on', source: 'build' }
  return { mode: null, source: null }
}

export function heatmapV2Mode () {
  return heatmapV2State().mode
}
